import NativeImage from 'fitify-ui-landing/src/components/Image/NativeImage'
import Markdown from 'markdown-to-jsx'
import * as React from 'react'

import {
  StyledContentWrapper,
  StyledFooter,
  StyledHeading1,
  StyledHeading2,
  StyledHeading3,
  StyledHeading4,
  StyledLink,
  StyledParagraph,
  StyleListItem,
  StyleUnorderedList,
  StyledSup,
  StyledStrong,
  StyledFirstParagraph,
} from './MarkdownContentRenderer.Styled'

type Props = {
  content: string
  contentWrapper?: React.ElementType
}
const MarkdownContentRenderer = ({ content, contentWrapper }: Props) => {
  return (
    <Markdown
      options={{
        wrapper: contentWrapper ?? StyledContentWrapper,
        forceBlock: true,
        overrides: {
          h1: StyledHeading1,
          h2: StyledHeading2,
          h3: StyledHeading3,
          h4: StyledHeading4,
          p: StyledParagraph,
          FirstParagraph: StyledFirstParagraph,
          a: StyledLink,
          ul: StyleUnorderedList,
          li: StyleListItem,
          NativeImage: {
            component: NativeImage,
            props: {
              width: '100%',
            },
          },
          sup: StyledSup,
          footer: StyledFooter,
          strong: StyledStrong,

          iframe: () => null,
          script: () => null,
          object: () => null,
          style: () => null,
        },
      }}
    >
      {content}
    </Markdown>
  )
}

export default MarkdownContentRenderer
